export default __webpack_public_path__ + "static/media/rhb-color-b.b1e6d147.svg";